export default __webpack_public_path__ + "static/media/udemy-official.2d13c5eb.svg";